<template>
    <div class="photo-lower-bar-button-group">
        <div class="photo-lower-bar-button" v-on:click="switchVisibilityBackgroundPlanes()">
            <SVGEye class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Скрыть/Показать плоскости</span>
        </div>
        <div class="photo-lower-bar-button" v-show="show" v-on:click="deleteSelectedPoint()">
            <SVGPhotoDelete class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Удалить точку</span>
        </div>
    </div>
</template>

<script>
    import SVGPhotoDelete from "../../SVG/SVGPhotoDelete";
    import {bus} from "../../../vue_bus";
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow";
    import SVGEye from "../../SVG/SVGEye";

    export default {
        name: "LeftLowerBarDeletePlane",
        components: {
            SVGEye,
            SVGAdminEditRow,
            SVGPhotoDelete
        },
        data() {
            return {
                show: false,
                visibilityBackgroundPlanes: true
            }
        },
        mounted() {
            bus.$on("showDeleteButton", this.showButton);
        },
        computed: {
            routeName() {
                return this.$store.state.route.name;
            }
        },
        methods: {
            deleteSelectedPoint() {
                bus.$emit("deletePoint");
            },
            switchVisibilityBackgroundPlanes() {
                this.visibilityBackgroundPlanes = !this.visibilityBackgroundPlanes
                bus.$emit("switchVisibilityBackgroundPlanes", this.visibilityBackgroundPlanes);
            },
            showButton(state) {
                this.show = state;
            }

        }
    }
</script>

<style scoped>

</style>
